import {
  Box,
  Flex,
  Heading,
  Text,
  Image,
  Container,
  Button,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import AOS from "aos";
import { Link } from "react-router-dom";
import { useContext } from "react";
// import resume from '../Assets/Resume/Sharvari-Hupare-Resume.pdf'
import { themeContext } from "../Context";
import about from "../Assets/img/about.png"
export const About = () => {
  useEffect(() => {
    AOS.init({ delay: 300 });
  }, []);
  const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
  return (
    <>
      <Box
        b="none"
        textAlign={"center"}
        id="about"
      
        className="about section"
        boxSizing="border-box"
        // bg={'#162030'}
        paddingBottom={'10%'}
        paddingTop={{ base: "60px", md: "80px" }} // Responsive padding for all screens
        color={"white"}
      >
        <Heading
          mt="60px"
          className="aboutmehead"
          display={"inline-block"}
          padding="10px"
          data-aos="fade-right"
          // ml="80px"
          mb="45px"
          textAlign={"center"}
          size="2xl"
          as="h1"
          fontFamily="initial"
        >
          <span style={{color: darkMode? 'white': 'black'}}>
          About{" "}
       
          <span style={{ color: "#FCA61F", textAlign: "center" }}>Me</span>
          </span>
        </Heading>
        <Flex
          justifyContent={"space-around"}
          direction={{
            base: "column",
            sm: "column",
            md: "column",
            lg: "row",
            xl: "row",
            "2xl": "row",
          }}
          gap="30px"
          alignItems={"center"}
        >
          <Box
            w={{
              base: "90%",
              sm: "90%",
              md: "70%",
              lg: "50%",
              xl: "40%",
              "2xl": "40%",
            }}
           
            data-aos="zoom-out"
            // style={{backgroundColor: darkMode? '': '#C1F5FF'}}
            rounded="md"
          >

{darkMode? (<Image
              w="100%"
              border={"1px inset"}
              boxShadow="dark-md"
              p="6"
              rounded="md"
              src="https://res.cloudinary.com/practicaldev/image/fetch/s--xq8xxUmL--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://external-preview.redd.it/x7vVnP3L75Wh4ApmXedKjze9b7ZuH5h7oW-4xbHMiHQ.jpg%3Fauto%3Dwebp%26s%3Db7d6873eed8c442bb685a083b3b4bfff6dd009ac"
              borderRadius={"10px"}
            />):(<Image
              w="100%"
              border={"1px inset"}
              boxShadow="dark-md"
              p="6"
              rounded="md"
              src={"https://i.postimg.cc/vB6rLYMS/about.png"}
              borderRadius={"10px"}
            />)}
            
          </Box>




          <Box
            w={{
              base: "90%",
              sm: "90%",
              md: "70%",
              lg: "50%",
              xl: "50%",
              "2xl": "50%",
            }}
          >
            <Text
              id="user-detail-intro"
              data-aos="fade-right"
              fontSize={"18px"}
              // color={"white"}
              textAlign={"left"}
              mb="20px"
              fontFamily="cursive"
            >
               <span style={{color: darkMode? 'white': '#788097'}}>
            Highly skilled  <span style={{ color: "#F5C32C",fontWeight:"bold"}}>Full Stack Web Developer</span> proficient in <span style={{ color: "#F5C32C",fontWeight:"bold"}}>MERN</span> stack.
            Completed 1200+ hours of Full Stack Web Development course at Masai school,
            gaining hands-on experience in building dynamic projects using <span style={{ color: "#F5C32C",fontWeight:"bold"}}>HTML, CSS, JS, React, Node.js, MongoDB, and Express.js.</span>
           
            <br/>
            <br/>
            I excel as a communicator and team player, with a knack for quick learning,
             making me a valuable asset in collaborative development environments.
             </span>
            </Text>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

// export default About;
